module.exports = __webpack_public_path__ + "static/media/icon_90.afdb8e24.svg";